import { PUBLIC_KEY } from '@/pages/home/_config/config';
import moment from 'moment';

// 明文加密
export const encryptedInfo = async (info: string, hasTime = true) => {
  try {
    // 动态引入包
    const forge = await import('node-forge');
    // 添加时间戳 给信息设置有效时间, 若无需时间要求时间戳值为-1
    const timeInfo = {
      plaintext: info,
      timestamp: hasTime ? moment().unix() : -1,
    };

    const formatInfo = JSON.stringify(timeInfo);
    const publicKey = forge.pki.publicKeyFromPem(PUBLIC_KEY);
    const infoBytes = forge.util.encodeUtf8(formatInfo);
    const encrypted = publicKey.encrypt(infoBytes, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
    });
    const encryptedBase64 = forge.util.encode64(encrypted);

    // 解密
    /*  try {
      var privateKey = forge.pki.privateKeyFromPem(PRIVATE_KEY);
      var encryptedBytes = forge.util.decode64(encryptedBase64);
      var decrypted = privateKey.decrypt(encryptedBytes, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
      });
      var decryptedText = forge.util.decodeUtf8(decrypted);
    } catch (err) {
      console.log('err', err);
    } */

    return encryptedBase64;
  } catch (err) {
    console.log(err);
    return info;
  }
};
